"use client";

import {
  FacebookRounded,
  Twitter,
  LinkedIn,
  Telegram,
} from "@mui/icons-material";
import React from "react";
import Link from "next/link";
import { Stack } from "@mui/material";
import IconStyle from "@/src/components/common/pages/social-icons/mui-custom/icon-style";
import { useSyncExternalStore } from "react";
import { usePathname } from "next/navigation";

const subscribeNever = () => () => {};

const SocialIcons = ({
  direction = "row",
}: {
  direction?: "row" | "column";
}) => {
  const pathname = usePathname();
  // window.location.origin is unknowable during SSR; useSyncExternalStore
  // hydrates with the empty server snapshot and re-renders with the real
  // origin, without the setState-in-effect cascade.
  const shareUrl = useSyncExternalStore(
    subscribeNever,
    () => `${window.location.origin}${pathname}`,
    () => "",
  );

  const socialLinks = [
    {
      icon: FacebookRounded,
      href: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      label: "Share on Facebook",
    },
    {
      icon: Twitter,
      href: `https://x.com/intent/tweet?url=${shareUrl}`,
      label: "Share on X",
    },
    {
      icon: LinkedIn,
      href: `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}`,
      label: "Share on LinkedIn",
    },
    {
      icon: Telegram,
      href: `https://t.me/share/url?url=${shareUrl}`,
      label: "Share on Telegram",
    },
  ];

  return (
    <Stack
      sx={{
        flexDirection:
          direction === "row"
            ? {
                md: "column",
                sm: "row",
                xs: "row",
              }
            : {
                md: "row",
                sm: "row",
                xs: "row",
              },

        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
      }}
    >
      {socialLinks.map((item) => (
        <Link
          href={item.href}
          key={item.label}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
        >
          <IconStyle aria-hidden="true">
            {React.createElement(item.icon as React.ComponentType<any>, {
              "aria-hidden": true,
              focusable: false,
            })}
          </IconStyle>
        </Link>
      ))}
    </Stack>
  );
};

export default SocialIcons;
